import { Container, Row, Col, Button, Form, ProgressBar } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import questionnaire_icon from "../../../images/Questionnaire_icon.png";
import Header from '../../Includes/Header';
import BackButton from '../../Includes/BackButton';
import { reduxForm, InjectedFormProps } from 'redux-form';
import { setwizardPageNumber, setQuestionnaireScreen5 } from '../../authslice';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { ToastBox } from 'MyComponents/Toaster';
import { useTranslation } from 'react-i18next';
import { updatePersonalKycDraftStep } from 'Utils/personalKycDraft';
import RadioButton from 'MyComponents/UI/RadioButton';

interface Props { }

const fundOptions = [
    { id: 'radio1', label: 'Under $1,000 USD', value: 'Under $1,000 USD' },
    { id: 'radio2', label: '$1,000 USD - $9,999 USD', value: '$1,000 USD - $9,999 USD' },
    { id: 'radio3', label: '$10,000 USD - $99,999 USD', value: '$10,000 USD - $99,999 USD' },
    { id: 'radio4', label: '$100,000 USD - $249,999 USD', value: '$100,000 USD - $249,999 USD' },
    { id: 'radio5', label: '$250,000 USD - $999,999 USD', value: '$250,000 USD - $999,999 USD' },
    { id: 'radio6', label: '$1,000,000 USD - $2,999,999 USD', value: '$1,000,000 USD - $2,999,999 USD' },
    { id: 'radio7', label: '$3000,000 USD - $4,999,999 USD', value: '$3000,000 USD - $4,999,999 USD' },
    { id: 'radio8', label: 'Other', value: 'Other' },
];

const Questionnaire_Screen5: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
    const questionnaireScreen5 = useSelector((state: RootState) => state.auth.questionnaireScreen5);
    const userID = useSelector((state: RootState) => state.auth.userID);

    const [selectedOption, setSelectedOption] = useState<string>('Under $1,000 USD');

    useEffect(() => {
        if (questionnaireScreen5) {
            setSelectedOption(questionnaireScreen5);
        }
    }, [questionnaireScreen5]);

    const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedOption(e.target.value);
    };

    const submitForm = () => {
        dispatch(setQuestionnaireScreen5(selectedOption));
        dispatch(setwizardPageNumber(page + 1));
        localStorage.setItem('pageNumber', `${page + 1}`);

        if (userID) {
            updatePersonalKycDraftStep(userID, 'questionnaire', { screen5: selectedOption });
            updatePersonalKycDraftStep(userID, 'wizardState', { pageNumber: page + 1 });
        }
    };

    return (
        <>
            <ToastBox />
            <Container fluid className="px-0 px-md-3">
                <Row className="g-0">
                    <Col md={12} className="mx-auto px-2 pt-0 pb-3">
                        <div className="mt-5">
                            <Row className="px-2 px-md-5">
                                <Col md={12}><BackButton /></Col>
                            </Row>
                            <Row className="px-2 px-md-5">
                                <Col md={12}>
                                    <div className="d-flex align-items-start py-3">
                                        <img src={questionnaire_icon} width={48} className="d-none d-md-block me-3 mt-1" alt="Questionnaire Icon" />
                                        <div>
                                            <h3 className="text-start m-0">{t('kyc.questionnaire')}</h3>
                                            <p className="fw-normal text-secondary m-0 mt-1 text-nowrap">{t('kyc.individual_form')}</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="px-2 px-md-5">
                                <Col md={12}>
                                    <div className="d-none d-md-flex align-items-center">
                                        <ProgressBar variant="primary" className="custom_progressbar mr-2" now={50} />
                                        <p className="fw-bold small py-3 px-3 m-0">5/7</p>
                                    </div>
                                    <p className="fw-bold text-start mt-4 m-0">{t('kyc.account_activity_q')}</p>
                                    <p className="text-secondary text-start small mt-1">{t('kyc.q5_desc')}</p>

                                    <Form noValidate onSubmit={handleSubmit(submitForm)}>
                                        <Row className='mt-4 text-start align-items-center'>
                                            {fundOptions.map(option => (
                                                <Col md={3} key={option.id}>
                                                    <RadioButton
                                                        id={option.id}
                                                        label={option.label}
                                                        value={option.value}
                                                        checked={selectedOption === option.value}
                                                        onChange={handleRadioChange}
                                                    />
                                                </Col>
                                            ))}
                                        </Row>

                                        <Row className="mt-4 text-start">
                                            <Col md={8}>
                                                <Button type="submit" className="btn btn-primary rounded-5" style={{ width: "220px" }}>
                                                    {t('common.next')}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
})(Questionnaire_Screen5);

export default connect(null)(form);
